var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbliterationAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 220 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 24,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontSize: 24
  }, "Abliteration"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8,
    dy: 2,
    fontSize: 12,
    fillOpacity: 0.6
  }, ".ai"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbliterationAi);
export default __webpack_public_path__ + "static/media/abliteration-ai.3bf0af319955b33a62957669e77bf705.svg";
export { ForwardRef as ReactComponent };